class AbstractModule extends EventHandler {

  constructor(name) {
    if (new.target === AbstractModule)
      throw "AbstractModule is abstract. Do not initialize it directly.";

    super();

    AbstractModule.list[name] = this;
    this.app = null;
  }

  attachSlaask(slaask) {
    this.app = slaask;

    this.app.on('server_config_fetched', (data) => {
      this._initData(data.detail.data);
    });

    this.app.on('widget_init', (data) => {
      this._initAfterWidget(data.detail.data);
    });

    this.app.on('texts_init', (data) => {
      this._initAfterTexts(data.detail.data);
    });

    this.app.on('guest_init', (data) => {
      this._initAfterGuest(data.detail.data);
    });
  }

  _initData(data) { }

  _initAfterWidget(widgetData) { }

  _initAfterTexts(textsData) { }

  _initAfterGuest(guestData) { }

  _autoInit(params) {
    Utils.autoFeed(this, params);
  }

  destroy() {
    this._trigger('destroy');
    let properties = Object.getOwnPropertyNames(this);
    Utils.forEach(properties, property => {
      delete this[property];
    });
  }

}

AbstractModule.list = {};
